/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_ViewInputs */

const he_common_view = /** @type {(inputs: Common_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צפה`)
};

const en_common_view = /** @type {(inputs: Common_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View`)
};

/**
* | output |
* | --- |
* | "View" |
*
* @param {Common_ViewInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const common_view = /** @type {((inputs?: Common_ViewInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_ViewInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_view(inputs)
	return en_common_view(inputs)
});